<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <FormInput
            :label="$t('formularios.id_simple')"
            name="ID"
            type="number"
            v-model="localData.n_abonado"
            rules="required"
        />
        <FormInput
            :label="$t('formularios.pin')"
            name="PIN"
            type="number"
            v-model="localData.pin"
            rules="required|max:4|min:4"
        />
        <div class="alert alert-danger d-flex align-items-center justify-content-between mt-3 p-1" v-if="error">
            <div class="pl-2">
                <b v-if="error === 'The given data was invalid.'">{{ $t('perfil.datos_no_validos') }}</b>
                <b v-else>{{ error.message }}</b>
            </div>
        </div>

        <div class="row">
            <div class="col-12 d-flex justify-content-between">
                <button type="submit" class="button" name="button" :disabled="loading">{{ $t('formularios.enviar') }}</button>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    export default {
        props: ['error', 'loading', 'data'],
        data() {
            return {
                localData: {
                    id_persona: this.data.id_persona || '',
                    pin: this.data.pin || ''
                }
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if (isValid) {
                    this.buscarAbono();
                }
            },
            buscarAbono() {
                this.$emit('buscarAbonado', this.localData);
            }
        }
    }
</script>
